import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { StoreState } from '@mm/state/store-interfaces';
import './MandatoryUpdateBanner.pcss';
import { PrimaryButton } from '../../buttons/PrimaryButton/PrimaryButton';
import Actions from '@mm/state/actions/actions';

export const MandatoryUpdateBanner = () => {
  const dispatch = useDispatch();
  const dismissBanner = () =>
    dispatch({ type: Actions.DISMISS_UPDATE_NOTIFICATION });
  const mandatoryUpdateBanner = useSelector(
    (state: StoreState) => state.mandatoryUpdateBanner,
  );
  const bannerContent = (() => {
    if (mandatoryUpdateBanner.mandatoryUpdate) {
      return (
        <>
          <span className="mandatory-update-banner__title">
            Update Available - Reload Required:
          </span>{' '}
          Please save your work and reload this application immediately. This
          page will automatically reload in{' '}
          {mandatoryUpdateBanner.secondsToReload} seconds.
        </>
      );
    }
    if (mandatoryUpdateBanner.recommendedUpdate) {
      return (
        <>
          <span className="mandatory-update-banner__title">
            Update Available:
          </span>{' '}
          Please save your work and reload this application as soon as possible.
        </>
      );
    }
  })();

  if (!bannerContent) {
    return null;
  }

  return (
    <div className="mandatory-update-banner">
      <div>{bannerContent}</div>
      <PrimaryButton
        className="mandatory-update-banner__reload"
        onClick={() => window.location.reload()}
      >
        <i className="fas fa-redo-alt" /> Reload
      </PrimaryButton>
      {mandatoryUpdateBanner.recommendedUpdate && (
        <div
          className="mandatory-update-banner__close-button"
          onClick={dismissBanner}
        >
          <i className="fas fa-times" />
        </div>
      )}
    </div>
  );
};
